// Material
import { Divider } from '@mui/material'
// Logic
import { InviteLink, InviteLinkUsage } from '@weblite/ts-action/hall'
// Common
import {
  UserListItemSkeleton,
  UserListItemWithStatus,
} from '$common/user-list-item'
import { EmptyStateList } from '$common/empty-state-list'
import { withSearchableInfiniteListPage } from '$common/searchable-list-page'
// Localization
import { t } from '$i18n'
import {
  useJoinedViaLinkMembers,
  useSearchedJoinedViaLinkMembers,
} from '$logic/hall/react-hook'

import { closeJoinedViaInviteLink, openUserProfile } from '$logic/router'

const ListItem = ({ userId }: InviteLinkUsage) => (
  <>
    <UserListItemWithStatus
      userId={userId}
      hasDivider={false}
      onClick={() => openUserProfile(userId)}
    />
    <Divider variant="inset" />
  </>
)

const Page = withSearchableInfiniteListPage<
  InviteLinkUsage,
  InviteLink,
  {
    inviteLink: InviteLink
    query: string
    fetchedItems: InviteLinkUsage[]
    hasMoreItemToLoad: boolean
  }
>({
  appBarTitle: t('profile.hall.joinedViaLink.title'),
  SkeletonItem: UserListItemSkeleton,
  EmptyStateComponent: () => <EmptyStateList />,
  fetchHook: useJoinedViaLinkMembers,
  searchHook: useSearchedJoinedViaLinkMembers,
  onBack: closeJoinedViaInviteLink,
})

export function JoinedViaInviteLink({
  inviteLink,
}: {
  inviteLink: InviteLink
}) {
  return (
    <Page
      fetchHookParams={inviteLink}
      getSearchHookParams={(query, items, hasMoreItemToLoad) => ({
        query,
        fetchedItems: items,
        inviteLink,
        hasMoreItemToLoad,
      })}
      ListItem={ListItem}
    />
  )
}
